import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=09ffba66&scoped=true"
import script from "./Event.vue?vue&type=script&lang=ts"
export * from "./Event.vue?vue&type=script&lang=ts"
import style0 from "./Event.vue?vue&type=style&index=0&id=09ffba66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ffba66",
  null
  
)

export default component.exports